import { Directive, ElementRef, Renderer2, AfterViewInit, OnDestroy } from "@angular/core";
import { NativeDesktopSupport } from "../../bfx-native-desktop/native-desktop-support";

/**
 * intended for bfx-context-menu host element or component
 *
 * openfin native desktop support code already handles this
 *
 */
@Directive({
  selector: "[bfxElementOnBody]",
  standalone: false,
})
export class BfxElementOnBody implements AfterViewInit, OnDestroy {
  private _originalParent: Element;

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    if (!NativeDesktopSupport.isNativeDesktopContainer() && this.el?.nativeElement != null) {
      this._originalParent = this.el?.nativeElement?.parentElement;
      document.body.appendChild(this.el.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (
      !NativeDesktopSupport.isNativeDesktopContainer() &&
      this._originalParent != null &&
      this.el?.nativeElement != null
    ) {
      this._originalParent.appendChild(this.el.nativeElement);
    }
  }
}
